// Dependencies
import React from 'react'

// Pages
import Gabaritos from "features/gabaritos";

export default Gabaritos;
